function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import React, { useMemo } from 'react';
import produce from 'immer';
import clsx from 'clsx';
import { propertySelectionToSegmentation } from 'common/query-builder/query-block/segment-menu/util';
import { Behavior, Segmentation } from 'common/types/reports/query';
import { withStyles } from 'common/util/react';
import { PropertyFilter } from 'common/widgets/property-filter-menu/models/property-filter';
import { StringOperator } from 'common/widgets/property-filter-menu/models/types';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { ButtonSize, ButtonTheme, ButtonType } from 'common/components/button/constants';
import { PropertyValuesScreenReact } from 'common/widgets/property-filter-menu/property-values-screen';
import { ButtonReact } from 'common/components/button';
import { Placement } from 'common/components/tooltip/types';
import { useTranslation } from 'common/i18n/hooks';
import css from './index.module.styl?inline';
import styles from './index.module.styl';
type Props = {
  selected: Segmentation;
  behavior: Behavior;
  operatorOpen: boolean;
  valueOpen: boolean;
  projectId: number;
  workspaceId: number;
  onOperatorOpen: () => void;
  onValueOpen: () => void;
  onChange: (selected: Segmentation) => void;
};
export const MultiAttributionBehaviorFilterSubItem = withStyles((props: Props) => {
  const {
    t
  } = useTranslation();
  const selectedFilter = useMemo(() => {
    var _props$behavior$filte;
    if ((_props$behavior$filte = props.behavior.filters) !== null && _props$behavior$filte !== void 0 && _props$behavior$filte[0]) {
      return new PropertyFilter(props.behavior.filters[0]);
    }

    // Show default property filter if in the process of adding initial touchpoint filter
    return new PropertyFilter(_objectSpread(_objectSpread({}, propertySelectionToSegmentation(props.behavior.property)), {}, {
      filterOperator: StringOperator.DoesNotEqual,
      filterValue: []
    }));
  }, [props.behavior]);
  return <div className={styles.container}>
      <SelectReact className={clsx(styles.select, styles.filterOperator, "filter-operator")} elref='filterOperator' open={props.operatorOpen} theme={SelectTheme.QbSubitem} size={ButtonSize.Small} sections={[{
      items: [{
        value: StringOperator.DoesNotEqual,
        label: t("query-builder.attribution.touchpoints-exclude")
      }, {
        value: StringOperator.Equals,
        label: t("query-builder.attribution.touchpoints-include")
      }].map(item => {
        return _objectSpread(_objectSpread({}, item), {}, {
          isSelected: item.value === selectedFilter.filterOperator
        });
      })
    }]} menuWidth={-1} onMenuChange={ev => ev.detail.isOpen && props.onOperatorOpen()} onChange={ev => props.onChange(produce(props.selected, draft => {
      draft.behavior.filters[0] = _objectSpread(_objectSpread({}, selectedFilter), {}, {
        filterOperator: ev.detail.item.value
      });
    }))} />
      <SelectReact className={clsx(styles.select, "filter-value-select")} elref='filterValueSelect' label={selectedFilter.isValid() ? selectedFilter.getValuesLabel() : t("query-builder.value-placeholder")} open={props.valueOpen} theme={SelectTheme.QbSubitem} size={ButtonSize.Small} onMenuChange={ev => ev.detail.isOpen && props.onValueOpen()}>
        {props.valueOpen && <PropertyValuesScreenReact elref='filterValue' slot='body' propertyFilter={selectedFilter.getAttributes()} displayValueOnly hideUndefinedValue projectId={props.projectId} workspaceId={props.workspaceId} onCommitPropertyFilter={ev => props.onChange(produce(props.selected, draft => {
        draft.behavior.filters[0] = ev.detail.propertyFilter.getAttributes();
      }))} />}
      </SelectReact>
      <ButtonReact className={styles.deleteButton} theme={ButtonTheme.Tertiary} size={ButtonSize.Inline} icon='x' role='button' type={ButtonType.Destructive} tooltip={{
      text: t("query-builder.attribution.remove-touchpoint-filter"),
      placement: Placement.Top
    }} onClick={() => props.onChange(produce(props.selected, draft => {
      draft.behavior.filters = [];
    }))} />
    </div>;
}, css);